export const SortMarkazFn = (markazSettings) => {
  const targetKeys = [
    'webAppFaramoshiRamz',
    'webAppLoginByMobile',
  ];

  const sortedMarkazSettings = markazSettings?.sort(
    (a, b) => {
      // Check if either a or b is in the targetIds list
      const aIndex = targetKeys.indexOf(a.Key);
      const bIndex = targetKeys.indexOf(b.Key);
      // If both a and b are in the targetIds list, sort by their index in the list
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      // If only a is in the targetIds list, it should come before b
      if (aIndex !== -1) {
        return -1;
      }
      // If only b is in the targetIds list, it should come before a
      if (bIndex !== -1) {
        return 1;
      }
      // If neither a nor b are in the targetIds list, their order does not change
      return 0;
    }
  );

  return sortedMarkazSettings;
};
